import { ApolloError } from '@apollo/client';

import { useApiGatewayQuery } from '~hooks';
import { PRODUCT_BY_SLUG } from '~queries';
import {
  GetProductBySlugQuery,
  GetProductBySlugQueryVariables,
  Maybe,
  Product,
} from '~types/appsync.types';

const useProductBySlug = (
  productSlug?: string,
): [Maybe<Product> | undefined, boolean, ApolloError | undefined] => {
  const { loading, error, data } = useApiGatewayQuery<
    GetProductBySlugQuery,
    GetProductBySlugQueryVariables
  >(PRODUCT_BY_SLUG, {
    skip: productSlug === undefined,
    variables: {
      productSlug: productSlug!,
    },
  });

  return [data?.productBySlug, loading, error];
};

export default useProductBySlug;
